import { Controller } from "@hotwired/stimulus"

// Updates browse_sort in the URL and reloads results (full page, or turbo frame on map view).
export default class extends Controller {
  change(event) {
    const sortKey = event.target.value
    const url = new URL(window.location.href)

    url.searchParams.set("browse_sort", sortKey)
    url.searchParams.delete("page")

    const frame = document.getElementById("results-list")
    const mapView = this.element.closest("[data-controller~='map-display']")?.querySelector("[data-map-display-target='map']")

    if (frame && mapView) {
      window.history.replaceState(window.history.state || {}, "", url.toString())
      frame.dataset.resetScrollOnRender = "true"
      frame.src = url.toString()
      return
    }

    window.location.assign(url.toString())
  }
}
